<template>
  <swiper class="screen-two-swiper" :options="swiperOption">
    <swiper-slide class="screen-one-swiper-item">
      <div class="swiper-slide-content">
        <div class="title">
          <div class="title__zh">信息服务</div>
          <div class="title__en">SERVICE ABILITY</div>
          <div class="title__line"></div>
        </div>
        <div class="content">
          <div class="content-item">
            <img src="@/assets/info_1.png" alt class="content-item-img" />
            <div class="content-item-word">
              <div class="content-item-word-frist">大数据信息化</div>
              <div>· 地区新能源车辆保有量 </div>
              <div>· 用户增长速度</div>
              <div>· 地区交通出行数据</div>
              <div>· 地区土地数据</div>
              <div>· 周边竞对数据</div>
            </div>
          </div>
          <div class="content-item">
            <img src="@/assets/info_2.png" alt class="content-item-img" />
            <div class="content-item-word">
              <div class="content-item-word-frist">选址算法模型</div>
              <div class="content-item-word">· 全方位数据分析</div>
              <div class="content-item-word">· 精准规划布局</div>
              <div class="content-item-word">· 提升覆盖率</div>
              <div class="content-item-word">· 规划建设内容和位置</div>
            </div>
          </div>
          <div class="content-item">
            <img src="@/assets/info_3.png" alt class="content-item-img" />
            <div class="content-item-word">
              <div class="content-item-word-frist">自建场站验证</div>
              <div class="content-item-word">· 极能充100+自营场站验证</div>
              <div class="content-item-word">· 单桩利用率高于市场平均20%</div>
              <div class="content-item-word">· 选址准确率高于90%</div>
            </div>
          </div>
        </div>
      </div>
    </swiper-slide>

    <div class="swiper-pagination swiper-pagination-white" slot="pagination"></div>
  </swiper>
</template>

<script>
import Button from "@/components/button";

export default {
  components: {
    Button
  },

  data() {
    return {
      swiperOption: {
        touchRatio: 0.8,
        speed: 800,
        parallax: true,
        // pagination: {
        //   el: ".swiper-pagination",
        //   clickable: true,
        //   renderBullet: (index, className) => {
        //     return `<div class="${className} full-swiper-pagination-custom-line"></div>`;
        //   }
        // }
      }
    };
  }
};
</script>

<style lang="less">
  @media screen and (min-width: 481px) {
    .screen-two-swiper {
      color: @white;
      height: 100%;

      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .swiper-slide-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 894px;
        height: 590px;

        .title {
          padding-top: 60px;
          margin: 0 auto;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;

          &__zh {
            font-size: 36px;
            color: @white;
          }

          &__en {
            color: @text-primary;
            text-transform: uppercase;
          }

          &__line {
            margin-top: 8px;
            width: 30px;
            height: 3px;
            background: linear-gradient(
                    90deg,
                    rgba(9, 154, 255, 1) 0%,
                    rgba(58, 254, 254, 1) 100%
            );
            border-radius: 10em;
          }
        }

        .content {
          width: 100%;
          display: flex;
          justify-content: space-between;
          margin-top: 30px;

          &-item {
            display: flex;
            flex-direction: column;
            align-items: center;

            &-img {
              width: 260px;
              height: 260px;
            }

            &-word {
              div {
                line-height: 2;
                &:not(.content-item-word-frist){
                  text-align: left;
                }
              }

              font-weight: 400;
              color: rgba(102, 132, 208, 1);
              font-size: 14px;
              text-align: center;
              font-family: PingFangSC-Regular, PingFang SC;

              &-frist {
                font-size: 18px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
              }
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 480px) {
    .screen-two-swiper {
      color: @white;
      height: 100%;
      &-item {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .swiper-slide-content {
        position: relative;
        display: flex;
        flex-direction: column;
        width: 894px;
        height: 590px;

        .title {
          padding-top: 60px;
          margin: 0 auto;
          text-align: center;
          display: flex;
          flex-direction: column;
          align-items: center;

          &__zh {
            font-size: 36px;
            color: @white;
          }

          &__en {
            color: @text-primary;
            text-transform: uppercase;
          }

          &__line {
            margin-top: 8px;
            width: 30px;
            height: 3px;
            background: linear-gradient(
                    90deg,
                    rgba(9, 154, 255, 1) 0%,
                    rgba(58, 254, 254, 1) 100%
            );
            border-radius: 10em;
          }
        }

        .content {
          width: 100%;
          margin-top: 20px;
          &-item {
            display: flex;
            flex-direction: row;
            justify-content: space-around;
            width: 90%;
            margin: 0 auto;
            &-img {
              width: 120px;
              height: 120px;
            }
            &-word {
              div {
                 text-align: center;
                line-height: 2;
              }
              display: flex;
              justify-content: center;
              align-items: self-end;
              flex-flow: column;
              font-weight: 400;
              color: rgba(102, 132, 208, 1);
              font-size: 13px;
              text-align: center;
              font-family: PingFangSC-Regular, PingFang SC;

              &-frist {
                width: 100%;
                text-align: left;
                font-size: 18px;
                font-weight: 500;
                color: rgba(255, 255, 255, 1);
              }
            }
          }
        }
      }
    }
  }
</style>